import React from 'react';
import { useSelector } from 'react-redux';

import EntityHeaderColumn from './EntityHeaderColumn';
import { equalityFn } from '../../../form-designer/utils/form-manager.utils';
import { HEADER_ITEM_DEFAULT_LABEL } from '../../constants/entity-designer.constants';
import { getEntityInfo } from '../../selectors/entity-designer.selectors';
import {
  getEntityStatusLabel,
  getReleaseVersion,
  modifyDate,
} from '../../utils/entity-designer.utils';

const EntityHeaderInfo = () => {
  const entity = useSelector(getEntityInfo, equalityFn);

  return (
    <>
      <EntityHeaderColumn
        firstRowTitle="Name: "
        secondRowTitle="Version: "
        firstRowValue={entity.EntityName}
        secondRowValue={entity.Version}
      />
      <EntityHeaderColumn
        firstRowTitle="Last Modified Date: "
        secondRowTitle="Release Type: "
        firstRowValue={modifyDate(entity.ModifiedDate) ?? HEADER_ITEM_DEFAULT_LABEL}
        secondRowValue={entity.ReleaseType ?? HEADER_ITEM_DEFAULT_LABEL}
      />
      <EntityHeaderColumn
        firstRowTitle="Status: "
        secondRowTitle="Release Version: "
        firstRowValue={getEntityStatusLabel(entity.Status)}
        secondRowValue={getReleaseVersion(entity.ReleaseVersion)}
      />
    </>
  );
};

export default EntityHeaderInfo;
